import React, { useCallback, useState } from 'react';

import { Box, Icon } from '@rbilabs/universal-components';

import Currency from 'components/currency';
import { CurrencyLineSkeleton } from 'pages/cart/currency-line-skeleton';
import { DonationsModal } from 'pages/cart/donations-modal';
import { IconContainer } from 'pages/cart/your-cart/styled';
import { hiddenAccessibilityPlatformProps } from 'utils/accessibility';

import { DonationLabel, Total, TotalsRow } from './styled';
import { IDonationsRowProps } from './types';

const DonationsRow: React.FC<React.PropsWithChildren<IDonationsRowProps>> = ({
  isLoading,
  iconAriaLabel,
  totalCents,
  message,
  modalContent,
  textProps,
}) => {
  const [showDonationsInfoModal, setShowDonationsInfoModal] = useState(false);

  const onOpenCallback = useCallback(() => {
    if (!modalContent) {
      return;
    }
    setShowDonationsInfoModal(true);
  }, [setShowDonationsInfoModal, modalContent]);

  const onCloseCallback = useCallback(() => {
    setShowDonationsInfoModal(false);
  }, [setShowDonationsInfoModal]);

  return (
    <>
      <TotalsRow {...(textProps && { ...textProps })}>
        {isLoading ? (
          <CurrencyLineSkeleton />
        ) : (
          <Box
            flexDirection="row"
            width="full"
            justifyContent="space-between"
            alignItems="center"
            maxHeight="$5"
          >
            <Box flexDirection="row" alignItems="center" maxHeight="$5">
              <DonationLabel {...(textProps && { ...textProps })}>{message}</DonationLabel>
              {iconAriaLabel && (
                <IconContainer
                  maxWidth={'$5'}
                  accessibilityLabel={iconAriaLabel}
                  onPress={onOpenCallback}
                >
                  <Icon
                    alignSelf={'center'}
                    variant="infoFill"
                    width="$3_5"
                    size={'xs'}
                    {...hiddenAccessibilityPlatformProps}
                  />
                </IconContainer>
              )}
            </Box>
            <Total testID="total-donation">
              <Currency textProps={textProps} amount={totalCents} />
            </Total>
          </Box>
        )}
      </TotalsRow>
      {modalContent && (
        <DonationsModal
          isOpen={showDonationsInfoModal}
          onCloseCallback={onCloseCallback}
          title={modalContent.title}
          modalAppearanceEventMessage={modalContent.modalAppearanceEventMessage}
          testID="tims-camps-donation-modal"
        >
          {modalContent.body}
        </DonationsModal>
      )}
    </>
  );
};

export default DonationsRow;
